import React from 'react'
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';

const PrivacyPolicy = () => {
    return (
        <PageWrapper isProtected={false} title={'Privacy Policy'} className={'bg-light'}>
            <Page className='p-0'>
                <div className='row h-100 align-items-center'>
                    <div className='shadow-3d-container'>

                        <h1>Privacy Policy</h1>

                        <p>
                            This Privacy Policy describes how we collect, use, and protect your information when you use our application.
                        </p>

                        <h3>1. Information We Collect</h3>
                        <p>
                            We may collect personal information such as your name, email address, phone number, and any other details you provide while using our services.
                        </p>

                        <h3>2. How We Use Your Information</h3>
                        <p>
                            We use the collected data for:
                        </p>
                        <ul>
                            <li>Providing and maintaining our service</li>
                            <li>Improving user experience</li>
                            <li>Communicating updates, offers, or support</li>
                        </ul>

                        <h3>3. Data Security</h3>
                        <p>
                            We implement appropriate security measures to protect your personal information from unauthorized access, disclosure, or misuse.
                        </p>

                        <h3>4. Sharing of Information</h3>
                        <p>
                            We do not sell or rent your personal data. We may share information with trusted third-party services only to operate our platform.
                        </p>

                        <h3>5. Cookies</h3>
                        <p>
                            We may use cookies to enhance your experience. You can disable cookies in your browser settings if you prefer.
                        </p>

                        <h3>6. Third-Party Services</h3>
                        <p>
                            Our application may include links to third-party websites. We are not responsible for their privacy practices.
                        </p>

                        <h3>7. Changes to This Policy</h3>
                        <p>
                            We may update this Privacy Policy from time to time. Changes will be posted on this page.
                        </p>

                        <h3>8. Contact Us</h3>
                        <p>
                            If you have any questions, please contact us at: [pro@neelssanjayraj.com]
                        </p>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    )
}

export default PrivacyPolicy
